/* OnePod homepage — finder, winkelwagen-koppeling, bezorgbelofte, animaties.
   Gebaseerd op het Claude Design-ontwerp; data uit assets/op-catalogus.js. */
(function () {
  'use strict';
  /* elke homepage-sectie laadt dit bestand; maar één keer initialiseren */
  if (window.__ophBoot) return;
  window.__ophBoot = true;
  var CAT = window.OP_CAT;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function euro(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  var CHECK = '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="#1B7F4D" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 10.5 8.5 15 16 5.5"></polyline></svg>';

  /* Bezorgbelofte: één bron, bezorg() in op-polish.js (pakket P4). op-polish.js laadt
     via op-brand eerder in de head (beide defer), dus window.opBezorg staat er al. */
  function bezorg() {
    return window.opBezorg ? window.opBezorg() : { kort: 'Verstuurd op de eerstvolgende werkdag', lang: 'Verstuurd op de eerstvolgende werkdag' };
  }
  function zetBezorg() {
    var b = bezorg();
    document.querySelectorAll('[data-oph-bezorg]').forEach(function (el) { el.textContent = b.kort; });
    document.querySelectorAll('[data-oph-bezorg-lang]').forEach(function (el) { el.textContent = b.lang; });
  }

  /* ---------- winkelwagen (Beautify-thema) ---------- */
  function cartAdd(variantId, btn) {
    if (btn) { btn.classList.add('is-wait'); btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'toevoegen mislukt'); });
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    }).catch(function (e) {
      alert('Dat lukte even niet: ' + e.message);
    }).finally(function () {
      if (btn) { btn.classList.remove('is-wait'); btn.disabled = false; }
    });
  }

  /* ---------- reveal-animaties ---------- */
  function reveal() {
    var els = document.querySelectorAll('.oph-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    /* Vangnet (09-09): de observer miste bij een drukke lading soms secties, die dan onzichtbaar
       bleven (opacity 0). Na 2,5 s, en 1 s na window.load, wordt alles alsnog getoond. */
    var toonAlles = function () { els.forEach(function (e) { e.classList.add('is-in'); }); };
    setTimeout(toonAlles, 2500);
    window.addEventListener('load', function () { setTimeout(toonAlles, 1000); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- FAQ ---------- */
  function faq() {
    document.querySelectorAll('[data-oph-faq]').forEach(function (wrap) {
      wrap.querySelectorAll('.oph-faq__item').forEach(function (item) {
        var btn = item.querySelector('.oph-faq__q');
        var ans = item.querySelector('.oph-faq__a');
        btn.addEventListener('click', function () {
          var open = !ans.hidden;
          wrap.querySelectorAll('.oph-faq__a').forEach(function (a) { a.hidden = true; });
          wrap.querySelectorAll('.oph-faq__item').forEach(function (i) { i.classList.remove('is-open'); });
          wrap.querySelectorAll('.oph-faq__q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          if (!open) { ans.hidden = false; item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ---------- productkaarten (populair) ---------- */
  function pcards() {
    document.querySelectorAll('[data-oph-pcard]').forEach(function (card) {
      var addBtn = card.querySelector('.oph-pcard__add');
      var hint = card.querySelector('.oph-pcard__varhint');
      var pills = card.querySelectorAll('.oph-pcard__var');
      var sel = null;
      if (hint) hint.setAttribute('aria-live', 'polite');
      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', 'false');
        if (p.classList.contains('is-uit') && !p.querySelector('.op-vh-uit')) {
          p.insertAdjacentHTML('beforeend', '<span class="visually-hidden op-vh-uit"> (uitverkocht)</span>');
        }
      });
      if (pills.length) {
        pills.forEach(function (p) {
          p.addEventListener('click', function () {
            pills.forEach(function (x) { x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
            p.classList.add('is-sel'); p.setAttribute('aria-pressed', 'true');
            sel = p;
            /* gekozen uitvoering ook in de links op beeld en titel, anders springt de
               productpagina naar de variant met voorraad (rw-prefer-stock) */
            card.querySelectorAll('a.oph-pcard__img, .oph-pcard__h a').forEach(function (a) {
              a.href = a.getAttribute('href').split('?')[0] + '?variant=' + p.dataset.variant;
            });
            if (hint) {
              if (p.dataset.beschikbaar === '1') { hint.textContent = '✓ Geschikt voor jouw set'; hint.classList.add('is-ok'); }
              else { hint.textContent = 'Deze uitvoering is tijdelijk uitverkocht'; hint.classList.remove('is-ok'); }
            }
            if (addBtn) {
              var kan = p.dataset.beschikbaar === '1';
              addBtn.textContent = kan ? 'In winkelwagen' : 'Uitverkocht';
              addBtn.classList.toggle('is-out', !kan);
              addBtn.classList.remove('is-wait');
              addBtn.disabled = false;
            }
          });
        });
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.classList.contains('is-out') || addBtn.classList.contains('is-wait')) return;
          var vid;
          if (pills.length) {
            if (!sel) {
              if (hint) { hint.textContent = 'Kies eerst je uitvoering'; hint.classList.remove('is-ok'); }
              return;
            }
            vid = sel.dataset.variant;
          } else {
            vid = addBtn.dataset.variant;
          }
          if (vid) cartAdd(vid, addBtn);
        });
      }
    });
  }

  /* ============================================================
     Finder
     ============================================================ */
  function finder(root) {
    var S = { step: 1, part: null, brand: null, model: null, optIdx: null, done: false, mnrOpen: false, na: null, naSoort: null, prod: null, laden: false, fout: null, seq: 0 };
    var $ = function (s) { return root.querySelector(s); };
    var titelEl = $('[data-f-title]'), stapEl = $('[data-f-step]'), meterEl = $('[data-f-meter]');
    if (titelEl) titelEl.setAttribute('tabindex', '-1');
    var crumbsEl = $('[data-f-crumbs]'), paneEl = $('[data-f-pane]'), backBtn = $('[data-f-back]');

    /* Meten (pixel "OnePod meten", 29-09-2026): de eerste keuze van een onderdeel is finder_gestart; een bereikt model (ook via het
       modelnummer) is model_gekozen, 1 keer per combinatie, pas als de uitkomst vaststaat. Shopify geeft het alleen door aan pixels
       met toestemming. */
    var gemeld = { gestart: false, model: '' };
    function meldFinder() {
      try {
        var sa = window.Shopify && window.Shopify.analytics;
        if (!sa || typeof sa.publish !== 'function') return;
        if (S.part && !gemeld.gestart) { gemeld.gestart = true; sa.publish('onepod:finder_gestart', { bron: 'home', onderdeel: partLabel(S.part) }); }
        var uitkomst = S.na ? (S.naSoort || 'netniet') : (S.done && S.prod) ? 'product' : (S.step === 4 && !S.done) ? 'uitvoering_kiezen' : '';
        var sleutel = S.model ? [S.part, S.brand, S.model].join('|') : '';
        if (!uitkomst || !sleutel || sleutel === gemeld.model) return;
        gemeld.model = sleutel;
        sa.publish('onepod:model_gekozen', { bron: 'home', onderdeel: partLabel(S.part), merk: (brand() || {}).name || S.brand || '', model: (model() || {}).name || S.model, uitkomst: uitkomst });
      } catch (e) { /* meten mag de finder niet breken */ }
    }

    function brand() { return CAT.brands.find(function (b) { return b.id === S.brand; }) || null; }
    function model() { var b = brand(); if (!b) return null; return b.models.find(function (m) { return m.id === S.model; }) || null; }
    function opties() { var m = model(); if (!m || !m.parts) return null; return m.parts[S.part] || null; }
    function totaal() { var o = opties(); return (o && o.length > 1) ? 4 : 3; }

    function partLabel(p) { return CAT.parts[p] || ''; }

    /* ---- productdata live ophalen (met staleness-guard: late antwoorden van een
       eerdere selectie mogen de state niet meer overschrijven) ---- */
    function laadProduct(optie) {
      var mijn = ++S.seq;
      S.laden = true; S.prod = null; S.fout = null;
      render();
      /* F2: dezelfde productdata als het finder-eindscherm (sections/op-finder-data.liquid). Die zegt per variant
         of hij op voorraad ligt of in nalevering staat (P4-regel); /products/<handle>.js kon dat niet. */
      fetch('/products/' + optie.h + '?section_id=op-finder-data', { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .then(function (t) {
          var box = document.createElement('div'); box.innerHTML = t;
          var j = box.querySelector('[data-opf-data]');
          if (!j) throw new Error('404');
          return JSON.parse(j.textContent);
        })
        .then(function (p) {
          if (mijn !== S.seq) return;
          var v = null;
          if (optie.vt) {
            v = p.varianten.find(function (x) { return x.titel.indexOf(optie.vt) >= 0; }) || null;
          }
          /* meerdere varianten zonder expliciete keuze (kleur), een firmware-optie, of een
             uitvoering die niet als variant bestaat: NIET blind toevoegen maar naar de productpagina */
          var moetKiezen = p.firmware || (optie.vt ? !v : p.varianten.length > 1);
          /* gekozen uitvoering ook in de productlink, anders springt de productpagina
             naar de variant met voorraad (rw-prefer-stock) */
          var url = v && !moetKiezen ? p.url + '?variant=' + v.id : p.url;
          if (!v) v = p.varianten.find(function (x) { return x.beschikbaar; }) || p.varianten[0];
          var prijzen = p.varianten.map(function (x) { return x.prijs; });
          S.prod = {
            handle: optie.h, url: url, titel: p.titel,
            img: p.img || '',
            variantId: v && !moetKiezen ? v.id : null,
            prijs: moetKiezen ? Math.min.apply(null, prijzen) : v.prijs,
            prijsVanaf: Math.min.apply(null, prijzen) !== Math.max.apply(null, prijzen),
            vergelijk: v && !moetKiezen && v.vergelijk ? v.vergelijk : null,
            beschikbaar: moetKiezen ? p.varianten.some(function (x) { return x.beschikbaar; }) : v.beschikbaar,
            voorraad: moetKiezen ? p.varianten.some(function (x) { return x.voorraad; }) : v.voorraad,
            variantTitel: optie.vt || null,
            kies: moetKiezen,
          };
          S.laden = false; render();
        })
        .catch(function (e) {
          if (mijn !== S.seq) return;
          S.laden = false;
          if (String(e && e.message) === '404') {
            S.naSoort = 'netniet';
            S.na = 'Dit onderdeel staat op dit moment niet online. Mail ons je modelnummer, dan zoeken we uit of we het op voorraad hebben. Vaak hebben we meer liggen dan er online staat.';
          } else {
            S.fout = optie; /* tijdelijke storing: opnieuw kunnen proberen */
          }
          render();
        });
    }

    function kiesModel(m) {
      if (m.na) { S.model = m.id; S.na = m.na; S.naSoort = 'firmware'; render(); return; }
      S.model = m.id; S.na = null; S.naSoort = null;
      var o = m.parts ? m.parts[S.part] : null;
      if (!o || !o.length) {
        if (S.part === 'T') {
          S.naSoort = 'tips';
          S.na = 'Voor dit model hebben we geen losse oortips online staan. Bekijk de accessoires of mail ons, dan kijken we wat er mogelijk is.';
        } else {
          S.naSoort = 'netniet';
          S.na = 'Dit onderdeel staat voor dit model niet online. Mail ons je modelnummer. Vaak hebben we meer op voorraad dan er online staat.';
        }
        render(); return;
      }
      if (o.length > 1) { S.step = 4; render(); return; }
      S.optIdx = 0; S.done = true; laadProduct(o[0]);
    }

    function mnrZoek(val) {
      var v = (val || '').trim().toUpperCase().replace(/\s/g, '');
      if (!v) return false;
      var hit = CAT.mnr[v];
      if (hit) {
        if (hit.na) { S.na = hit.na; S.naSoort = 'firmware'; S.brand = 'apple'; render(); return true; }
        S.brand = 'apple';
        var b = brand();
        var m = b.models.find(function (x) { return x.id === hit.model; });
        if (!m) return false;
        S.model = m.id; S.na = null;
        var o = m.parts ? m.parts[S.part] : null;
        if (!o || !o.length) { kiesModel(m); return true; }
        var idx = 0;
        if (hit.vt) {
          var gevonden = o.findIndex(function (x) { return x.vt === hit.vt; });
          if (gevonden >= 0) idx = gevonden;
          else if (o.length > 1) { S.step = 4; render(); return true; }
        } else if (o.length > 1) { S.step = 4; render(); return true; }
        S.optIdx = idx; S.done = true; laadProduct(o[idx]);
        return true;
      }
      /* overige merken: zoek in de codes van alle modellen */
      for (var bi = 0; bi < CAT.brands.length; bi++) {
        var bb = CAT.brands[bi];
        for (var mi = 0; mi < bb.models.length; mi++) {
          var mm = bb.models[mi];
          if ((mm.codes || []).some(function (c) { return String(c).toUpperCase() === v; })) {
            S.brand = bb.id; kiesModel(mm); return true;
          }
        }
      }
      return false;
    }

    /* Na een keuze wordt de hele pane vervangen; de aangeklikte knop verdwijnt en de
       focus valt naar <body>. Deze vlag zegt: deze render komt uit een handeling IN de
       finder, dus verplaats de focus naar de nieuwe kop. Nooit bij de eerste render en
       nooit bij een laat antwoord van de fetch. */
    var wilFocus = false;

    /* ---- render ---- */
    function render() {
      meldFinder();
      var st = S.done || S.na ? 99 : S.step;
      var tot = totaal();
      var getoond = Math.min(S.step, tot);
      var titels = { 1: 'Wat mis je?', 2: 'Welk merk heb je?', 3: 'Welk model heb je?', 4: 'Welke uitvoering heeft jouw set?' };
      var m = model();
      if (st === 4 && m && m.vraag) titels[4] = m.vraag;

      var naTitels = { firmware: 'Dit model verkopen we bewust niet online', tips: 'Losse oortips: even overleggen', netniet: 'Net niet online: we helpen je persoonlijk' };
      if (S.fout) titelEl.textContent = 'Dat lukte even niet';
      else titelEl.textContent = S.na ? (naTitels[S.naSoort] || naTitels.netniet) : (S.done ? 'Dit onderdeel past bij jouw set' : titels[Math.min(S.step, 4)]);
      stapEl.textContent = S.done || S.na || S.fout ? 'Klaar' : 'Stap ' + getoond + ' van ' + tot;
      meterEl.style.width = (S.done || S.na) ? '100%' : (Math.round(((getoond - 1) / tot) * 100) + 8) + '%';

      /* kruimels */
      var crumbs = [];
      if (S.part) crumbs.push({ lbl: partLabel(S.part), go: function () { wilFocus = true; S.seq++; Object.assign(S, { step: 1, part: null, brand: null, model: null, optIdx: null, done: false, na: null, naSoort: null, prod: null, fout: null, laden: false, mnrOpen: false }); render(); } });
      if (S.brand) crumbs.push({ lbl: (brand() || {}).name, go: function () { wilFocus = true; S.seq++; Object.assign(S, { step: 2, brand: null, model: null, optIdx: null, done: false, na: null, naSoort: null, prod: null, fout: null, laden: false, mnrOpen: false }); render(); } });
      if (S.model && (S.done || S.na || S.fout || S.step > 3)) crumbs.push({ lbl: (model() || { name: S.model }).name, go: function () { wilFocus = true; S.seq++; Object.assign(S, { step: 3, model: null, optIdx: null, done: false, na: null, naSoort: null, prod: null, fout: null, laden: false }); render(); } });
      crumbsEl.innerHTML = '';
      crumbsEl.hidden = crumbs.length === 0 || (S.step === 1 && !S.done && !S.na && !S.fout);
      crumbs.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'oph-crumbchip'; b.title = 'Wijzig deze keuze';
        b.innerHTML = esc(c.lbl) + '<i>✕</i>';
        b.addEventListener('click', c.go);
        crumbsEl.appendChild(b);
      });

      backBtn.hidden = S.done || S.na || S.fout ? false : S.step === 1;
      paneEl.innerHTML = maakPane();
      koppelPane();

      if (wilFocus) {
        wilFocus = false;
        if (!paneEl.contains(document.activeElement) && !crumbsEl.contains(document.activeElement)) {
          titelEl.focus({ preventScroll: true });
        }
      }
    }

    function maakPane() {
      if (S.fout) return paneFout();
      if (S.na) return paneNa();
      if (S.done) return paneResultaat();
      if (S.step === 1) return panePart();
      if (S.step === 2) return paneBrand();
      if (S.step === 3) return paneModel();
      if (S.step === 4) return paneVariant();
      return '';
    }

    function panePart() {
      var arrow = '<span class="oph-partbtn__arrow" aria-hidden="true">→</span>';
      var items = [
        { g: 'L', t: 'Linker oortje', s: 'Alleen het linkeroortje' },
        { g: 'R', t: 'Rechter oortje', s: 'Alleen het rechteroortje' },
        { g: 'C', t: 'Oplaadcase', s: 'Case kwijt of defect' },
        { g: 'T', t: 'Oortips', s: 'Dopjes & kleine onderdelen' },
      ];
      return '<div class="oph-finder__parts">' + items.map(function (i) {
        return '<button type="button" class="oph-partbtn" data-part="' + i.g + '">'
          + '<span class="oph-partbtn__glyph">' + i.g + '</span>'
          + '<span><span class="oph-partbtn__t">' + i.t + '</span><span class="oph-partbtn__s">' + i.s + '</span></span>'
          + arrow + '</button>';
      }).join('') + '</div>';
    }

    function paneBrand() {
      return '<div class="oph-finder__brands">' + CAT.brands.map(function (b) {
        var binnen = b.logo ? '<img src="' + esc(b.logo) + '" alt="' + esc(b.name) + '" loading="lazy">' : '<b>' + esc(b.name) + '</b>';
        return '<button type="button" class="oph-brandbtn" data-brand="' + esc(b.id) + '" title="' + esc(b.name + ': ' + (b.sub || '')) + '">' + binnen + '</button>';
      }).join('') + '</div>'
        + '<p class="oph-finder__note">Staat je merk er niet tussen? <a href="mailto:klantenservice@reway.nl">Mail ons</a>, vaak hebben we meer op voorraad dan er online staat.</p>';
    }

    function paneModel() {
      var b = brand();
      if (!b) return '';
      var grid = '<div class="oph-finder__models">' + b.models.map(function (m, i) {
        var img = m.img ? '<img src="' + esc(m.img) + '" alt="" loading="lazy">' : '';
        return '<button type="button" class="oph-modelbtn' + (m.na ? ' oph-modelbtn--na' : '') + '" data-model="' + i + '">' + img + '<span>' + esc(m.name) + '</span></button>';
      }).join('') + '</div>';
      var mnr = '';
      var heeftCodes = b.id === 'apple' || b.models.some(function (m) { return (m.codes || []).length; });
      if (heeftCodes) {
        mnr = '<div class="oph-mnr">'
          + '<button type="button" class="oph-mnr__toggle" data-mnr-toggle aria-expanded="' + (S.mnrOpen ? 'true' : 'false') + '">Ik weet mijn model niet: vind het via het modelnummer van je andere oortje'
          + ' <svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 4 13 10 6 16"></polyline></svg></button>'
          + '<div class="oph-mnr__panel"' + (S.mnrOpen ? '' : ' hidden') + ' data-mnr-panel>'
          + '<div><p class="oph-mnr__h">Vind je modelnummer in 10 seconden</p>'
          + (b.id === 'apple'
            ? '<p class="oph-mnr__s">Op je iPhone, met je AirPods verbonden:</p><ol class="oph-mnr__steps"><li><i>1</i><span>Open <strong>Instellingen</strong> → <strong>Bluetooth</strong></span></li><li><i>2</i><span>Tik op de <strong>ⓘ</strong> naast je AirPods</span></li><li><i>3</i><span>Scroll naar <strong>Modelnummer</strong></span></li></ol><p class="oph-mnr__fine">Het nummer staat ook in kleine letters op je andere oortje en op de onderkant van de oplaadcase.</p>'
            : '<p class="oph-mnr__s">Het modelnummer staat in kleine letters op je <strong>andere oortje</strong> (het exemplaar dat je nog hebt) en op de onderkant van de oplaadcase.</p>')
          + '</div>'
          + '<div><label class="oph-mnr__lbl" for="oph-mnr-input">Modelnummer</label>'
          + '<div class="oph-mnr__row"><input id="oph-mnr-input" class="oph-mnr__input" data-mnr-input placeholder="' + (b.id === 'apple' ? 'bijv. A2698' : 'bijv. ' + esc((b.models.find(function (m) { return (m.codes || []).length; }) || { codes: ['…'] }).codes[0])) + '" autocomplete="off">'
          + '<button type="button" class="oph-mnr__go" data-mnr-go>Herken model</button></div>'
          + '<p class="oph-mnr__fail" data-mnr-fail hidden>Dit nummer herkennen we nog niet. <a href="mailto:klantenservice@reway.nl?subject=Welk%20onderdeel%20past%3F%20(modelnummer%3A%20)">Mail ons je modelnummer</a>, dan zoeken we het juiste onderdeel voor je uit.</p>'
          + '</div></div></div>';
      }
      return grid + mnr;
    }

    function paneVariant() {
      var o = opties() || [];
      var knoppen = '<div class="oph-finder__vars">' + o.map(function (x, i) {
        return '<button type="button" class="oph-varbtn" data-opt="' + i + '"><span class="oph-varbtn__t">' + esc(x.label || 'Uitvoering ' + (i + 1)) + '</span><span class="oph-varbtn__s">' + esc(x.sub || '') + '</span></button>';
      }).join('') + '</div>';
      var m = model();
      var hulp = '';
      if (m && m.id === 'pro2') {
        hulp = '<div class="oph-caseshelp"><button type="button" class="oph-caseshelp__t" data-casehelp-toggle>Ik weet het niet</button>'
          + '<p class="oph-caseshelp__p" data-casehelp hidden>Kijk naar de poort onderop je case: een <strong>USB-C</strong>-aansluiting is ovaal en breed, een <strong>Lightning</strong>-aansluiting is smal met afgeronde hoeken. Twijfel je? Het modelnummer op de onderkant geeft uitsluitsel. Of <a href="mailto:klantenservice@reway.nl">mail ons</a>.</p></div>';
      }
      return knoppen + hulp;
    }

    function paneFout() {
      return '<div class="oph-finder__na"><h3>Even geen verbinding</h3>'
        + '<p>Het lukte net niet om de actuele voorraad op te halen. Dat ligt aan de verbinding, niet aan jouw keuze.</p>'
        + '<div style="display:flex;gap:10px;flex-wrap:wrap;">'
        + '<button type="button" class="oph-btn oph-btn--primary" data-retry>Probeer opnieuw</button>'
        + '<a class="oph-btn oph-btn--ghost" href="mailto:klantenservice@reway.nl">Mail ons</a>'
        + '</div></div>';
    }

    function paneNa() {
      var b = brand();
      var mailto = 'mailto:klantenservice@reway.nl?subject=' + encodeURIComponent('Welk onderdeel past? (' + ((model() || {}).name || (b || {}).name || 'model') + ')');
      return '<div class="oph-finder__na"><h3>' + esc((model() || {}).name || '') + '</h3>'
        + '<p>' + esc(S.na) + '</p>'
        + '<p>Liever geen verkoop dan een onderdeel dat bij jou niet koppelt. Mail ons je modelnummer, dan zoeken we het voor je uit.</p>'
        + '<div style="display:flex;gap:10px;flex-wrap:wrap;">'
        + '<a class="oph-btn oph-btn--primary" href="' + mailto + '">Mail ons je modelnummer</a>'
        + (S.part === 'T' ? '<a class="oph-btn oph-btn--ghost" href="' + esc(CAT.tipsFallback) + '">Bekijk accessoires</a>' : (b && b.collection ? '<a class="oph-btn oph-btn--ghost" href="' + esc(b.collection) + '">Bekijk alle ' + esc(b.name) + '-onderdelen</a>' : ''))
        + '</div></div>';
    }

    function paneResultaat() {
      var b = brand() || {}, m = model() || {};
      var o = (opties() || [])[S.optIdx || 0] || {};
      if (S.laden || !S.prod) {
        return '<p style="margin:0;font-size:15px;color:var(--oph-mut);">Even kijken of het op voorraad ligt…</p>';
      }
      var p = S.prod;
      var variantLbl = p.kies ? 'Kies op de productpagina' : (o.label || (o.vt ? o.vt : 'Standaard uitvoering'));
      var bz = bezorg();
      var stock = p.kies && p.beschikbaar
        ? '<p class="oph-result__stock"><i></i>Meer uitvoeringen</p><p class="oph-result__ship">Kies op de productpagina welke bij jouw set past</p>'
        : p.beschikbaar && p.voorraad
        ? '<p class="oph-result__stock is-ok"><i></i>Op voorraad</p><p class="oph-result__ship">' + esc(bz.kort) + '</p>'
        : p.beschikbaar
          ? '<p class="oph-result__stock is-out"><i></i>Nalevering</p><p class="oph-result__ship">Verwacht binnen 3-5 werkdagen</p>'
          : '<p class="oph-result__stock is-out"><i></i>Tijdelijk uitverkocht. Mail ons voor de levertijd</p><p class="oph-result__ship">We reserveren er graag één voor je</p>';
      var acts;
      if (p.kies) {
        /* meerdere kleur-/firmware-varianten: keuze hoort op de productpagina */
        acts = '<a class="oph-btn oph-btn--primary" href="' + esc(p.url) + '">Kies je uitvoering op de productpagina</a>';
      } else if (p.beschikbaar) {
        acts = '<button type="button" class="oph-btn oph-btn--primary" data-res-add>In winkelwagen</button><a class="oph-btn oph-btn--ghost" href="' + esc(p.url) + '">Bekijk product</a>';
      } else {
        acts = '<a class="oph-btn oph-btn--primary" href="mailto:klantenservice@reway.nl?subject=' + encodeURIComponent('Beschikbaarheid: ' + p.titel) + '">Mail ons</a><a class="oph-btn oph-btn--ghost" href="' + esc(p.url) + '">Bekijk product</a>';
      }
      var gids = b.guide ? '<div class="oph-result__spec"><span>Koppelgids</span><b><a href="' + esc(b.guide) + '" style="color:var(--oph-accent);text-decoration:none;">Stap voor stap →</a></b></div>' : '';
      return '<div class="oph-result">'
        + '<div><div class="oph-result__okwrap"><span class="oph-result__okic">' + CHECK.replace('width="15" height="15"', 'width="22" height="22"') + '</span><p class="oph-result__oktitle">Gevonden.</p></div>'
        + '<p class="oph-result__lead">Dit is het onderdeel dat bij jouw set past. Na levering koppel je het in een paar minuten met de koppelgids.</p>'
        + '<div class="oph-result__specs">'
        + '<div class="oph-result__spec"><span>Jouw set</span><b>' + esc(m.name || '') + '</b></div>'
        + '<div class="oph-result__spec"><span>Onderdeel</span><b>' + esc(partLabel(S.part)) + '</b></div>'
        + '<div class="oph-result__spec"><span>Uitvoering</span><b>' + esc(variantLbl) + '</b></div>'
        + (p.kies ? '<div class="oph-result__spec"><span>Compatibiliteit</span><b>Kies kleur/uitvoering op de productpagina</b></div>' : '<div class="oph-result__spec"><span>Compatibiliteit</span><span class="is-ok">' + CHECK + 'Koppelbaar met je huidige set</span></div>')
        + gids + '</div>'
        + '<button type="button" class="oph-result__again" data-res-again>Opnieuw zoeken</button></div>'
        + '<div class="oph-result__prod">'
        + '<div class="oph-result__pimg">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.titel) + '" loading="lazy">' : '') + '</div>'
        + '<div style="min-width:0;">'
        + '<p class="oph-result__pbrand">' + esc(b.name || '') + '</p>'
        + '<p class="oph-result__pname">' + esc(m.name || '') + ' · ' + esc(partLabel(S.part).toLowerCase()) + (o.vt ? ' (' + esc(o.vt) + ')' : '') + '</p>'
        + '<p class="oph-result__pprice">' + (p.kies && p.prijsVanaf ? 'vanaf ' : '') + euro(p.prijs) + (p.vergelijk ? ' <s>' + euro(p.vergelijk) + '</s>' : '') + '</p>'
        + stock
        + '<div class="oph-result__acts">' + acts + '</div>'
        + '</div></div></div>';
    }

    /* ---- events per pane ---- */
    function koppelPane() {
      paneEl.querySelectorAll('[data-part]').forEach(function (b) {
        b.addEventListener('click', function () {
          wilFocus = true;
          S.part = b.dataset.part;
          S.step = S.brand ? 3 : 2; /* merk kan voorgeselecteerd zijn via de merktegels */
          render();
        });
      });
      paneEl.querySelectorAll('[data-brand]').forEach(function (b) {
        b.addEventListener('click', function () { wilFocus = true; S.brand = b.dataset.brand; S.step = 3; render(); });
      });
      paneEl.querySelectorAll('[data-model]').forEach(function (b) {
        b.addEventListener('click', function () { wilFocus = true; kiesModel(brand().models[Number(b.dataset.model)]); });
      });
      paneEl.querySelectorAll('[data-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          wilFocus = true;
          S.optIdx = Number(b.dataset.opt); S.done = true;
          laadProduct(opties()[S.optIdx]);
        });
      });
      var mt = paneEl.querySelector('[data-mnr-toggle]');
      if (mt) mt.addEventListener('click', function () {
        S.mnrOpen = !S.mnrOpen;
        var pnl = paneEl.querySelector('[data-mnr-panel]');
        pnl.hidden = !S.mnrOpen;
        mt.setAttribute('aria-expanded', S.mnrOpen ? 'true' : 'false');
        if (S.mnrOpen) { var inp = paneEl.querySelector('[data-mnr-input]'); if (inp) inp.focus(); }
      });
      var mgo = paneEl.querySelector('[data-mnr-go]');
      var minp = paneEl.querySelector('[data-mnr-input]');
      function doeMnr() {
        var fail = paneEl.querySelector('[data-mnr-fail]');
        wilFocus = true;
        var ok = mnrZoek(minp.value);
        if (!ok) wilFocus = false; /* niets gerenderd: focus blijft in het invoerveld */
        if (!ok && fail) fail.hidden = !minp.value.trim();
      }
      if (mgo) mgo.addEventListener('click', doeMnr);
      if (minp) minp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doeMnr(); } });
      var ct = paneEl.querySelector('[data-casehelp-toggle]');
      if (ct) ct.addEventListener('click', function () { var p = paneEl.querySelector('[data-casehelp]'); p.hidden = !p.hidden; });
      var rt = paneEl.querySelector('[data-retry]');
      if (rt) rt.addEventListener('click', function () { wilFocus = true; var o = S.fout; S.fout = null; laadProduct(o); });
      var ra = paneEl.querySelector('[data-res-add]');
      if (ra) ra.addEventListener('click', function () { if (S.prod && S.prod.variantId) cartAdd(S.prod.variantId, ra); });
      var rg = paneEl.querySelector('[data-res-again]');
      if (rg) rg.addEventListener('click', resetAll);
    }

    function resetAll() {
      wilFocus = true;
      S.seq++;
      Object.assign(S, { step: 1, part: null, brand: null, model: null, optIdx: null, done: false, mnrOpen: false, na: null, naSoort: null, prod: null, laden: false, fout: null });
      render();
    }

    backBtn.addEventListener('click', function () {
      wilFocus = true;
      S.seq++;
      if (S.done || S.na || S.fout) {
        S.done = false; S.na = null; S.naSoort = null; S.prod = null; S.fout = null; S.laden = false;
        var o = opties();
        S.step = (o && o.length > 1) ? 4 : 3;
        if (!brand()) S.step = 2;
        if (!S.model) S.step = brand() ? 3 : 2;
        render(); return;
      }
      if (S.step === 4) { S.step = 3; S.optIdx = null; }
      else if (S.step === 3) { S.step = 2; S.brand = null; S.model = null; S.mnrOpen = false; }
      else { S.step = 1; S.part = null; S.brand = null; S.model = null; }
      render();
    });

    /* voorselectie vanaf de merk- en categorietegels elders op de pagina */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-oph-open-finder]');
      if (!t) return;
      e.preventDefault();
      var merkId = t.dataset.merk || null;
      var part = t.dataset.part || null;
      resetAll();
      if (merkId && CAT.brands.some(function (b) { return b.id === merkId; })) S.brand = merkId;
      if (part) { S.part = part; S.step = S.brand ? 3 : 2; }
      wilFocus = true;
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    render();
  }

  /* ---------- init ---------- */
  function init() {
    zetBezorg();
    setInterval(zetBezorg, 60000);
    reveal();
    faq();
    pcards();
    var f = document.querySelector('[data-oph-finder]');
    if (f && CAT) {
      finder(f);
    } else {
      /* geen finder of catalogus op deze pagina: merk-/kwijt-tegels sturen dan
         gewoon door naar de finder-hubpagina i.p.v. geruisloos niets te doen */
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-oph-open-finder]');
        if (!t) return;
        e.preventDefault();
        window.location.href = '/pages/product-finder';
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
